// src/PostHogPageViewTracker.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from './posthog';
import { sanitizeUrl } from './posthog-sanitization';

export default function PostHogPageViewTracker() {
    const location = useLocation();

    useEffect(() => {
        // Pass pre-sanitized path/url to avoid leaking accountId, facilityId, patientId in query params
        const pathWithHash = location.pathname + (location.hash || '');
        const sanitizedPath = sanitizeUrl(pathWithHash);
        posthog.capture('$pageview', {
            $pathname: sanitizedPath,
            $current_url: sanitizeUrl(window.location?.href || pathWithHash),
        });
    }, [location.pathname, location.hash]);

    return null;
}
